// extracted by mini-css-extract-plugin
module.exports = {"content":"GradingandAcademicProgress_content__7cRB5","text":"GradingandAcademicProgress_text__24Bbo"};